import signUpJson from '../../../assets/translations/sign-up.json'

export const languageContent: any = signUpJson
